<template>
  <b-badge :variant="resolveColor"> {{ resolveLabel }} </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  props: {
    value: String | Number,
  },
  computed: {
    resolveLabel() {
      return this.value === "active"
        ? "فعّال"
        : this.value === "inactive"
        ? "متوقف"
        : "مجمّد";
    },
    resolveColor() {
      return this.value === "active"
        ? "light-success"
        : this.value === "inactive"
        ? "light-secondary"
        : "light-danger";
    },
  },
};
</script>
